export class AlgemeneMeldingInput {

  constructor(
    public content: string,
    public actiefVanDag: string,
    public actiefTotDag: string,
  ) {
  }
}
